import type { Site } from '@hotjar/site';
import { noop } from '@hotjar/webapp/lib/function';
import { useEffectOnceWithDependencies } from '@hotjar/webapp/hooks/useEffectOnceWithDependencies';
import { useTrack } from '@hotjar/webapp/hooks/useTrack';
import { useTrafficCoverage } from '@hotjar/webapp/hooks/useTrafficCoverage';

interface UseModalLoadedTrackingProps {
  referrer: string;
  site: Site | undefined;
  additionalTrackingData?: Record<string, string | number>;
  modalVersion: string;
  modalName: string;
}

export const useModalLoadedTracking = ({
  referrer,
  site,
  additionalTrackingData,
  modalVersion,
  modalName,
}: UseModalLoadedTrackingProps): void => {
  const { loadedModal, closedModal, getGroupDataForSite } = useTrack();
  const { coveragePercentage } = useTrafficCoverage();

  useEffectOnceWithDependencies(
    () => {
      if (!site) {
        return noop;
      }

      loadedModal(modalName, getGroupDataForSite(site), {
        modal_version: modalVersion,
        ui_position: referrer,
        shown_traffic_coverage: coveragePercentage,
        ...additionalTrackingData,
      });

      return () => {
        closedModal(modalName, getGroupDataForSite(site), {
          modal_version: modalVersion,
          ui_position: referrer,
        });
      };
    },
    [closedModal, site, getGroupDataForSite, loadedModal, referrer],
    () => !!site,
  );
};
